<template>
  <div class="qr-box" v-if="qrFlag">
    <div class="qr-mask" @click="handleClose"></div>
    <div class="qr-main">
      <img class="close" @click="handleClose" src="../assets/certificate-icon/close-icon.png" alt="">
      <div class="qr-main-title">分享</div>
      <div class="pic">
        <img :src="qrUrl" alt="二维码" />
        <img class="bg" src="../assets/images/image.png" alt="">
      </div>
      <div class="qr-main-commit">微信扫码分享给朋友</div>
    </div>
  </div> 
</template>
<script>
import QRCode from 'qrcode'
import qs from 'qs'
export default {
  name: 'PublicShare',
  data() {
    return {
      qrFlag: false,
      qrUrl: ''
    }
  },
  methods: {
    handleShare(pathName, query) {
      if (!(pathName && query)) return
      this.qrFlag = true
      const { origin } = window.location
      QRCode.toDataURL(
        `${origin}/${pathName}?${qs.stringify(query)}`,
        { errorCorrectionLevel: 'L', margin: 2, width: 300, height: 300 },
        (err, url) => {
          if (err) {
            this.$message.error('分享失败，请重试')
            return
          }
          this.qrUrl = url
        }
      )
    },
    handleClose() {
      this.qrFlag = false
    }
  }
}
</script>
<style lang='scss' scoped>
.qr-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  .qr-mask {
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .qr-main {
    width: 516px;
    height: 586px;
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .close {
      width: 38px;
      height: 38px;
      position: absolute;
      right: -45px;
      top: -82px;
      cursor: pointer;
    }
    .qr-main-title {
      width: 100%;
      height: 76px;
      background: #1c6ace;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 76px;
      text-align: center;
    }
    .pic {
      text-align: center;
      margin: 50px auto 30px;
      position: relative;
      .bg {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 320px;
        height: 320px;
        transform: translate(-50%, -50%);
      }
    }
    > img {
      display: block;
      margin: 50px auto 30px;
    }
    .qr-main-commit {
      text-align: center;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #000000;
    }
  }
}
</style>
